import {InjectionToken} from '@angular/core';
import {AppEnvironment} from '@models/environment';

export const APP_ENVIRONMENT = new InjectionToken<AppEnvironment>('App Environment');
